<script>import ButtonBox from "./ButtonBox.svelte";
import { attrValue } from "../../../../utils/html";
export let props = {};
</script>

<ButtonBox
	on:click
	props={{
		...props,
		classNames: attrValue([
			props.classNames,
			`${props.withBorder ? 'bg-transparent border border-white text-white' : 'bg-white text-text'}`
		])
	}}
>
	<slot />
</ButtonBox>
